export default {
  CREATE_DISPUTE: "ROLE_CREATE_DISPUTE",
  UPDATE_DISPUTE: "ROLE_CREATE_DISPUTE",
  VIEW_DISPUTE: "ROLE_VIEW_DISPUTE",

  CREATE_REASON_CODE: "ROLE_CREATE_REASON_CODE",
  UPDATE_REASON_CODE: "ROLE_UPDATE_REASON_CODE",
  VIEW_REASON_CODE: "ROLE_VIEW_REASON_CODE",

  CREATE_TRANSACTION_GROUP: "ROLE_CREATE_TRANSACTION_GROUP",
  UPDATE_TRANSACTION_GROUP: "ROLE_UPDATE_TRANSACTION_GROUP",
  VIEW_TRANSACTION_GROUP: "ROLE_VIEW_TRANSACTION_GROUP",

  CREATE_TRANSACTION_TYPE: "ROLE_CREATE_TRANSACTION_TYPE",
  UPDATE_TRANSACTION_TYPE: "ROLE_UPDATE_TRANSACTION_TYPE",
  VIEW_TRANSACTION_TYPE: "ROLE_VIEW_TRANSACTION_TYPE",

  CREATE_DISPUTE_REGION: "ROLE_CREATE_DISPUTE_REGION",
  UPDATE_DISPUTE_REGION: "ROLE_UPDATE_DISPUTE_REGION",
  VIEW_DISPUTE_REGION: "ROLE_VIEW_DISPUTE_REGION",

  CREATE_TRANSACTION_TIMELINE: "ROLE_CREATE_TRANSACTION_TIMELINE",
  DELETE_TRANSACTION_TIMELINE: "ROLE_DELETE_TRANSACTION_TIMELINE",
  UPDATE_TRANSACTION_TIMELINE: "ROLE_UPDATE_TRANSACTION_TIMELINE",
  VIEW_TRANSACTION_TIMELINE: "ROLE_VIEW_TRANSACTION_TIMELINE",

  CREATE_DISPUTE_TIMELINE: "ROLE_CREATE_DISPUTE_TIMELINE",
  DELETE_DISPUTE_TIMELINE: "ROLE_DELETE_DISPUTE_TIMELINE",
  UPDATE_DISPUTE_TIMELINE: "ROLE_UPDATE_DISPUTE_TIMELINE",
  VIEW_DISPUTE_TIMELINE: "ROLE_VIEW_DISPUTE_TIMELINE",

  VIEW_SETTLEMENT_RULE: "ROLE_VIEW_SETTLEMENT_RULE",
  CREATE_SETTLEMENT_RULE: "ROLE_CREATE_SETTLEMENT_RULE",
  DELETE_SETTLEMENT_RULE: "ROLE_DELETE_SETTLEMENT_RULE",
  UPDATE_SETTLEMENT_RULE: "ROLE_UPDATE_SETTLEMENT_RULE",

  CREATE_MERCHANT_DISPUTANT: "ROLE_CREATE_MERCHANT_DISPUTANT",
  DELETE_MERCHANT_DISPUTANT: "ROLE_DELETE_MERCHANT_DISPUTANT",
  VIEW_MERCHANT_DISPUTANT: "ROLE_VIEW_MERCHANT_DISPUTANT",

  VIEW_SCRIPT: "ROLE_VIEW_SCRIPT",
  UPDATE_SCRIPT: "ROLE_UPDATE_SCRIPT",

  VIEW_SETTLEMENT: "ROLE_VIEW_SETTLEMENT",

  VIEW_SETTLEMENT_REQUEST: "ROLE_VIEW_SETTLEMENT_REQUEST",
  VIEW_SETTLEMENT_REPORT: "ROLE_VIEW_SETTLEMENT_REPORT",
  PROCESS_SETTLEMENT_REQUEST: "ROLE_PROCESS_SETTLEMENT_REQUEST"
};



// WEBPACK FOOTER //
// ./src/configurations/permissions.js